<formstep-detail :options="options" :editable="canEdit" :model="statusfunktion" :html-id="'name_und_modul'"></formstep-detail>